rwgps = window.rwgps || {};

rwgps.Overlay = function(opts) {
  if(opts) {
    this.opts = opts;
    switch(opts.type) {
      case "osm":
        return new rwgps.Overlay.OSM(opts);
      case "arcgis":
        return new rwgps.Overlay.ArcGIS(opts);
      case "wms":
        return new rwgps.Overlay.WMS(opts);
    }
  }
}
rwgps.Overlay.prototype = {
  init: function(opts) {
    this.opts = opts;
    this.url = opts.url;
    this.provider = opts.provider || "google";
    this.map = opts.map;
    this.width = opts.width || 256;
    this.height = opts.height || 256;
  },
  setProvider: function(provider, map) {
    this.provider = provider;
    this.map = map;
  }
}

rwgps.Overlay.WMS = function(opts) {
  this.init(opts);
  this.requestOpts = opts.requestOpts || {
    f: "image",
    transparent: "true",
    format: "png8",
    bboxSR: "4326"
  }
}
rwgps.Overlay.WMS.prototype = new rwgps.Overlay();
rwgps.Overlay.WMS.prototype.getParamString = function() {
  var str = []
  _.each(this.requestOpts, function(val, key) {
    str.push(key+"="+val);
  });
  return str.join("&");
}
rwgps.Overlay.WMS.prototype.getOverlayObj = function() {
  if(this.provider == "google") {
    var self = this;
    return new google.maps.ImageMapType({
      getTileUrl: function(coord, zoom) {
        var proj = self.map.getProjection();
        var zfactor = Math.pow(2, zoom);
        var tpt = new google.maps.Point((coord.x)*self.width/zfactor, (coord.y)*self.height/zfactor);
        var bpt = new google.maps.Point((coord.x+1)*self.width/zfactor, (coord.y+1)*self.height/zfactor);
        var top = proj.fromPointToLatLng(tpt);
        var bot = proj.fromPointToLatLng(bpt);
        return self.url+"?" + self.getParamString()+"&size="+self.width+","+self.height+
          "&bbox=" + top.lng() + "," + bot.lat() + "," + bot.lng() + "," + top.lat();
      },
      isPng: true,
      name: self.opts.name,
      tileSize: new google.maps.Size(self.width, self.height),
      minZoom: self.opts.minZoom,
      maxZoom: self.opts.maxZoom
    });
  } else {
    return L.TileLayer.WMS(this.url, {
      layers: this.opts.layers,
      format: "image/png",
      version: this.opts.version || "1.3",
      transparent: true,
      width: this.width,
      height: this.height
    });
  }
}

rwgps.Overlay.OSM = function(opts) {
  this.init(opts);
}
rwgps.Overlay.OSM.prototype = new rwgps.Overlay();
rwgps.Overlay.OSM.prototype.getOverlayObj = function() {
  if(this.provider == "google") {
    var self = this;
    return new google.maps.ImageMapType({
      getTileUrl: function(coord, zoom) {
        var str = self.url + zoom + "/" + coord.x + "/" + coord.y + ".png";
        var sub = String.fromCharCode(Math.floor(Math.random()*3) + 97);
        if(self.opts.key && self.opts.key.length > 0) {
          str += "?apikey=" + self.opts.key
        }
        return str.replace("{s}", sub);
      },
      tileSize: new google.maps.Size(256, 256),
      isPng: true,
      alt: self.opts.alt,
      name: self.opts.name,
      maxZoom: self.opts.maxZoom
    });
  } else {
    return L.TileLayer(this.url, {maxZoom: this.opts.maxZoom});
  }
}

rwgps.Overlay.ArcGIS = function(opts) {
  this.init(opts);
}
rwgps.Overlay.ArcGIS.prototype = new rwgps.Overlay();
rwgps.Overlay.ArcGIS.prototype.getOverlayObj = function() {
  if(this.provider == "google") {
    var self = this;
    return new google.maps.ImageMapType({
      getTileUrl: function(coord, zoom) {
        //var sub = String.fromCharCode(Math.floor(Math.random()*4+1) + 97);
        var sub = Math.floor(Math.random()*4+1);
        var base = self.url.replace(/%{num}/, sub);
        return base + '/tile/' + zoom + "/" + coord.y + "/" + coord.x + "?token=" + (self.opts.token || '');
      },
      tileSize: new google.maps.Size(256, 256),
      isPng: true,
      alt: this.opts.alt,
      name: this.opts.name,
      maxZoom: this.opts.maxZoom
    });
  } 
}



// WEBPACK FOOTER //
// ./public/javascripts/js_maps/overlay.js